import { Drawer, Input, Image, notification } from 'antd';
import { IoMdSend } from 'react-icons/io';
import { useLocation } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { IconContext } from 'react-icons/lib';
import moment from 'moment';
import ClientJobHeader from './ClientJobHeader';
import '../../styles/components/MarketPlace/CommentSection.scss';
import { getJobComments, addJobComment } from '../../services/API/MarketplaceService';
import defaultUserImage from '../../assets/default_user_image.png';
import { useTranslation } from 'react-i18next';

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const ReactIcon = ({ callback }) => {
  return (
    <IconContext.Provider value={{ color: '#fff', size: '25px' }}>
      <div style={{ background: '#D34714', borderRadius: '50%' }} onClick={callback}>
        <IoMdSend style={{ padding: '5px', marginLeft: '1px' }} />
      </div>
    </IconContext.Provider>
  );
};

const CommentWindow = ({ data, lastComment }) => {
  return (
    <div className="comment-container" style={{ marginBottom: lastComment ? '2em' : null }}>
      <Image src={data?.imageUrl ? data?.imageUrl : defaultUserImage} className="user-image" />
      <div className="comment-text-container">
        <p className="user-name">{`${data?.firstName}`} {data?.lastName.toLowerCase().includes('unknown') ? '': data?.lastName}</p>
        <p className="comment-text">{data?.comment}</p>
        <p className="comment-date">
          {moment(data?.createdAt).isValid()
            ? moment(data?.createdAt).format('MMM DD, YYYY [at] hh:mm A')
            : null}
        </p>
      </div>
    </div>
  );
};

const CommentSection = ({ open, close, jobData,getCommentsCount }) => {
  const query = useQuery();
  const [commentData, setCommentData] = useState([]);
  const [commentText, setCommentText] = useState('');
  let selectedCity = query.get('city');
  const userId = localStorage.getItem('userId');
  const {t, i18n}= useTranslation();

  if (!selectedCity) {
    selectedCity = localStorage.getItem('preferredLocation');
  }

  useEffect(() => {
    if (open) {
      getJobCommentsData(jobData?.companyName);
    }
  }, [open]);

  const getJobCommentsData = companyName => {
    getJobComments(companyName)
      .then(response => {
        if (response?.status === 200) {
          // console.log(response?.data);
          return response?.data;
        }
      })
      .then(responseObj => {
        setCommentData(
          responseObj?.data.sort((a, b) => {
            return moment.utc(b?.createdAt).diff(moment.utc(a?.createdAt));
          })
        );
      })
      .catch(error => {
        console.log(error);
      });
  };

  const addJobCommentData = () => {
    if (!commentText && !commentText.length) {
      notification.error({
        message: t('comment_required_ack'),
      });
      return;
    }

    const companyName = jobData?.companyName;
    const userComment = commentText;
    setCommentText('');

    addJobComment({
      userId,
      companyName,
      cityName: selectedCity,
      comment: userComment,
    })
      .then(response => {
        getJobCommentsData(jobData?.companyName);
        setCommentText('');
        getCommentsCount(jobData?.companyName);
      })
      .catch(error => {
        setCommentText('');
        notification.error({
          message: 'Something went wrong, Please try again!',
        });
        console.log(error);
      });
  };

  const handleCommentChange = data => {
    setCommentText(data?.target?.value);
  };

  return (
    <div className="main-container">
      <Drawer
        title={<ClientJobHeader jobData={jobData} />}
        open={open}
        onClose={close}
        key="commentSection"
        placement="bottom"
        closable={false}
        height="80%"
      >
        <p className="comment-heading">All Comments</p>
        {commentData.map((item, index) => (
          <CommentWindow
            key={`${item?.userId}${index}`}
            data={item}
            lastComment={index === commentData.length - 1}
          />
        ))}
        <div className="input-box-main-container">
          <Input
            className="input-box"
            type="search"
            placeholder={t('type_comment')}
            suffix={<ReactIcon callback={addJobCommentData} />}
            onPressEnter={addJobCommentData}
            onChange={handleCommentChange}
            value={commentText}
            size={"large"}
            style={{
              marginTop: '1.5em',
              marginLeft:'24px'
            }}
          />
        </div>
      </Drawer>
    </div>
  );
};

export default CommentSection;
